import { useMutation } from "@tanstack/react-query";
import apiClient from "lib/api-client";

const getS3link = async (formData) => {
  const res = await apiClient.post("/api/v9/serviceRequest/uploadDocForVision", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res?.data?.data;
};

export const useGetFileToS3link = () => {
  return useMutation({
    mutationFn: getS3link,
  });
};
